export default "/images/vendor/flag-icons/flags/1x1/tm.svg?38a7e313a4359d76c568583bbc3488fb";